import request from './index';

export function addDeviceType(data) {
  return request.post('officialDeviceType/add', data);
}

export function updateDeviceType(data) {
  return request.post('officialDeviceType/update', data);
}

export function deleteDeviceType(id) {
  return request.post('officialDeviceType/delete', { id });
}

export function getDeviceTypePage(params) {
  return request.get('officialDeviceType/page', { params });
}

export function getDeviceTypeDetail(id) {
  return request.get('officialDeviceType/detail', { params: { id } });
}

export function getDeviceTypeList(params) {
  return request.get('officialDeviceType/list', { params });
}
